import React from 'react';
import { Grid, GridColumn } from 'semantic-ui-react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import { searchInfoTypes } from '../constants';
import SearchTotalResults from '../components/SearchTotalResults';
import AiSearchBanner from '../components/AiSearchBanner';

const SearchBanner = ({ aiSearch, datasetCount, searchStatus }) => (
  <Grid>
    <GridColumn align="center">
      { aiSearch && (<AiSearchBanner datasetCount={datasetCount} searchStatus={searchStatus} />) }
      { !aiSearch && (<SearchTotalResults datasetCount={datasetCount} searchStatus={searchStatus} />)}
    </GridColumn>
  </Grid>
);

const mapStateToProps = ({
  search: { searches },
}, { category, code }) => {
  const searchItem = findResult(searches, category, code);

  const aiSearch = searchItem?.info?.some((item) => item.type === searchInfoTypes.VECTOR_SEARCH);

  return (
    {
      aiSearch,
      datasetCount: searchItem?.count || 0,
      searchStatus: searchItem?.searchStatus || states.NONE,
    }
  );
};

export default connect(mapStateToProps)(SearchBanner);
